import type { SvgIconComponent } from "@mui/icons-material";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import ChecklistIcon from "@mui/icons-material/ChecklistRounded";
import type { WorkbookFilter } from "../../../../api/types/workbookRuns.types";

const getWorkbookFilterIcon = (filter: WorkbookFilter): SvgIconComponent | null => {
  if (filter.type === "Date" || filter.type === "Daterange") {
    return CalendarTodayRoundedIcon;
  }
  if (filter.type === "Table") {
    return ChecklistIcon;
  }

  return null;
};

export default getWorkbookFilterIcon;
